import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify'; 

const API_BASE = `${process.env.REACT_APP_BASEURL}/product`;

export default function Tax() {
    const [taxes, setTaxes] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [formData, setFormData] = useState({
        tax_rate: ''
    });

    useEffect(() => {
        fetchTaxes();
    }, []);

    const fetchTaxes = async () => {
        try {
            // Note: Added your adminAuth token here just in case your API requires it
            const res = await fetch(`${API_BASE}/taxes/`, {
                headers: {
                    Authorization: `Token ${localStorage.getItem("adminAuth")}`
                }
            });
            const data = await res.json();
            setTaxes(data);
        } catch (error) {
            console.error("Error fetching taxes:", error);
            toast.error("Failed to load taxes");
        }
    };

    // --- Form Handlers ---
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const url = editingId ? `${API_BASE}/taxes/${editingId}/` : `${API_BASE}/taxes/`;
        const method = editingId ? 'PUT' : 'POST';

        try {
            const res = await fetch(url, {
                method: method,
                headers: { 
                    'Content-Type': 'application/json',
                    Authorization: `Token ${localStorage.getItem("adminAuth")}`
                },
                body: JSON.stringify(formData)
            });

            if (res.ok) {
                fetchTaxes();
                resetForm();
                toast.success(`Tax ${editingId ? 'updated' : 'created'} successfully!`);
            } else {
                toast.error("Failed to save tax");
            }
        } catch (error) {
            console.error("Error saving tax:", error);
            toast.error("An error occurred");
        }
    };

    const handleEdit = (tax) => {
        setEditingId(tax.id);
        setFormData({
            tax_rate: tax.tax_rate
        });
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this tax rate?")) return;
        try {
            const res = await fetch(`${API_BASE}/taxes/${id}/`, { 
                method: 'DELETE',
                headers: {
                    Authorization: `Token ${localStorage.getItem("adminAuth")}`
                }
            });
            if (res.ok) fetchTaxes();
        } catch (error) {
            console.error("Error deleting tax:", error);
        }
    };

    const resetForm = () => {
        setEditingId(null);
        setFormData({ tax_rate: '' });
    };

    return (
        <div className="max-w-2xl mx-auto p-6">
            <h1 className="text-2xl font-bold mb-6">Manage Tax Rate</h1>

            <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-8">
                <div className="mb-6">
                    <label className="block text-gray-700 text-sm font-bold mb-2">Tax Rate (%)</label>
                    <input 
                        name="tax_rate" 
                        type="number" 
                        step="0.01" 
                        required 
                        value={formData.tax_rate} 
                        onChange={handleInputChange} 
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none" 
                    />
                </div>

                <div className="flex items-center justify-between">
                    <button type="submit" className="bg-blue-600 hover:bg-blue-800 text-white font-bold py-2 px-4 rounded focus:outline-none">
                        {editingId ? 'Update Tax' : 'Create Tax'}
                    </button>
                    {editingId && (
                        <button type="button" onClick={resetForm} className="text-gray-500 hover:text-gray-800 font-bold">
                            Cancel Edit
                        </button>
                    )}
                </div>
            </form>

            <div className="bg-white shadow-md rounded px-8 pt-6 pb-8">
                <h2 className="text-xl font-bold mb-4">Existing Taxes</h2>
                <table className="min-w-full leading-normal">
                    <thead>
                        <tr>
                            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">ID</th>
                            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Rate</th>
                            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {taxes.map(tax => (
                            <tr key={tax.id}>
                                <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">#{tax.id}</td>
                                <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">{tax.tax_rate}%</td>
                                <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                    <button onClick={() => handleEdit(tax)} className="text-blue-500 hover:text-blue-800 mr-3">Edit</button>
                                    <button onClick={() => handleDelete(tax.id)} className="text-red-500 hover:text-red-800">Delete</button>
                                </td>
                            </tr>
                        ))}
                        {taxes.length === 0 && (
                            <tr>
                                <td colSpan="3" className="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center text-gray-500">
                                    No taxes found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}